/**********************************************************************************************************************/
/* FILE: hafas_webapp_renderinitial.js                                                                */
/**********************************************************************************************************************/

HafasWebapp.prototype.preloadTemplates = function (callback) {
  var templates = [
    // *** Überarbeitung Barrierefreiheit *** //
    'common.html',
    'common.new.html',
    'common.content.html',
    'common.page_header.html',
    'common.page_navigation.html',
    'common.actionbar.html',
    'common.buttons.html',
    'common.links.html',
    'common.icons.html',
    'common.input.html',
    'common.input_datetime.html',
    'common.segmentedControl.html',
    'common.input_selectbox.html',
    'common.suggest.html',
    'common.options.html',
    'common.newmessages.html',
    'common.product.html',
    'common.overlays.html',
    'tp.form.input.html',
    'tp.index.html',
    'tp.result.html',
    'tp.result.connection.html',
    'tp.result.dayselector.html',
    'tp.result.details.html',
    // *************************************** //
    // 'common.overlay.html', // Strawberry-Template, soll nicht mehr verwendet werden
    // 'common.partials.html', // Strawberry-Template, soll nicht mehr verwendet werden
    // 'common.tabs.html', // Strawberry-Template, soll nicht mehr verwendet werden
    // 'common.messages.html', // Strawberry-Template, soll nicht mehr verwendet werden
    // 'common.calendar.html', // Strawberry-Template, soll nicht mehr verwendet werden
    'common.map.html',
    'tq.result.html'
  ];
  if (Hafas.Config.Switches.useStationboard) {
    templates.push('sq.index.html');
    templates.push('sq.form.fields_favorites.html');
    templates.push('sq.result.html');
    templates.push('sq.result.lineGroup.html');
    templates.push('sq.result.info.html');
    templates.push('sq.result.print.html');
  }

  if( Hafas.Config.Switches.useAnalysisToolkit) {
    templates.push('jt.index.html');
    templates.push('jt.data_additional.html');
    templates.push('jt.data_overview.html');
    templates.push('jt.data_errors.html');
  }
  if (Hafas.Config.Switches.useImprint) {
    templates.push('imprint.index.html');
  }

  Hafas.Modules.Loader.loadTemplateFiles(templates, function () {
    callback();
  });
};

/* renderInitialElements */
HafasWebapp.prototype.renderInitialElements = function () {
  // Render PageHeader

  var _me = this;
  var modelPage = {};
  modelPage.languages = (Hafas.Config.Switches.useLanguageSwitch) ? [] : false;
  if (modelPage.languages) {
    var langIdx = 0,
      langLen = Hafas.Config.languages.length;
    for (langIdx; langIdx < langLen; langIdx++) {
      var lang = Hafas.Config.languages[langIdx];
      lang.label = Hafas.Modules.i18n.get(lang.label);
      if (Hafas.Config.currLangObj.lang == lang.lang) {
        lang.isActive = true;
      }
      modelPage.languages.push(lang);
    }
  }

  /**
   * Erweiterung des Hafas.Config-Objekts mit Angaben zum Navigator
   * Hafas.Config.Navigator wird um canIUseNativeInputfields erweitert
   *
   * Wird fuer die Abfrage in den Formularen gebraucht, ob native Felder gerendert werden sollen oder nicht.
   * Wird aber nur dann ueberprueft, wenn in der config.json useTDPNativeFallback auf "true" gesetzt ist.
   *
   * Geprueft wird hier auf verschiedene Eigenschaften des Browser.
   * Desktop-Browser und das Surface verfuegen nicht ueber window.orientation
   * Ipad, iPhone und Motorola Zoom mit Android 5.0 allerdings schon
   *
   * Besonderheit: Es wird noch nach dem pointerEnabled-Wert gefragt. Bis jetzt ist er nur mit dem Surface
   * aufgetaucht und auch da nur mit dem Edge! Aber auch hier wollen wir keine nativen Felder.
   */
  if (Hafas.Config.useTDPNativeFallback == true) {
    if (typeof window.orientation != 'undefined') {
      Hafas.Config.Navigator.canIUseNativeInputfields = true;
    }
    else {
      Hafas.Config.Navigator.canIUseNativeInputfields = false;
    }
    // ueberpruefe ob Hafas.Config.Navigator.pointerEnabled vorhanden ist
    // Bis jetzt hat nur das Surface mit Edge den Wert true gesetzt, alle anderen waren undefined
    if (typeof Hafas.Config.Navigator.pointerEnabled != 'undefined' && Hafas.Config.Navigator.pointerEnabled) {
      Hafas.Config.Navigator.canIUseNativeInputfields = false;
    }
  }
  else {
    Hafas.Config.Navigator.canIUseNativeInputfields = false;
  }

  /* Navigation aufbauen */
  modelPage.navigation = {};
  modelPage.navigation.showLanguages = true;
  modelPage.navigation.languages = modelPage.languages;

  // Hafas.Config.showPageHeader == true: es wird nur das Kundenlogo im Header angezeigt, die sichtbar geschalteten Men�-Punkte befinden sich in den Tabs, der Rest im Seitenmen�
  // Hafas.Config.showPageHeader == false: Das Standard-Verhalten f�r Desktop, nur die Navigationsreiter und das Seitenmen� werden angezeigt
  if (Hafas.Config.showPanCakeMenu && Hafas.Config.Switches.useTabNavigation) {
    modelPage.navigation.tabs = Hafas.Config.tabNavigation;
    modelPage.navigation.pageNavigation = Hafas.Core.clone(Hafas.Config.tabNavigation);
    modelPage.navigation.pageNavigation = modelPage.navigation.pageNavigation.concat(Hafas.Config.headerNavigation);
  }

  // Hafas.Config.showPageHeader == true: es wird nur das Kundenlogo im Header angezeigt, alle anderen Men�punkte befinden sich im Seitenmen�
  // Hafas.Config.showPageHeader == false: kein Header, �ber dem Formular wird eine �berschrift mit dem aktuellen Konzext angezeigt, alle Men�punkte befinden sich im Seitenmen�
  if (Hafas.Config.showPanCakeMenu && !Hafas.Config.Switches.useTabNavigation) {
    modelPage.navigation.pageNavigation = Hafas.Config.tabNavigation;
    modelPage.navigation.pageNavigation = modelPage.navigation.pageNavigation.concat(Hafas.Config.headerNavigation);
  }

  // �ber dem Formular wird nur der Titel des aktuellen Kontexts angezeigt, es gibt keine Navigation
  if (!Hafas.Config.showPanCakeMenu && !Hafas.Config.showPageHeader && !Hafas.Config.Switches.useTabNavigation) {
    // keine Men�punkte
  }

  // Die sichtbar geschalteten Men�-Punkte befinden sich in den Tabs, alle anderen im PageHeader
  if (!Hafas.Config.showPanCakeMenu && Hafas.Config.showPageHeader && Hafas.Config.Switches.useTabNavigation) {
    modelPage.navigation.tabs = Hafas.Config.tabNavigation;
    modelPage.navigation.headerNavigation = Hafas.Config.headerNavigation;
    modelPage.navigation.showLanguages = true;
  }

  // Alle Men�punkte werden im Header angezeigt, keine Tab-Navigation, �ber dem Formular wird der Titel des aktuellen Kontext angezeigt
  if (!Hafas.Config.showPanCakeMenu && Hafas.Config.showPageHeader && !Hafas.Config.Switches.useTabNavigation) {
    modelPage.navigation.headerNavigation = Hafas.Config.tabNavigation;
    modelPage.navigation.headerNavigation = modelPage.navigation.headerNavigation.concat(Hafas.Config.headerNavigation);
    modelPage.navigation.showLanguages = true;
  }

  // Nur die sichtbar konfigurierten Tabs werden angezeigt, keine weiteren Men�punkte (Sprachumschaltung fehlt dann)
  if (!Hafas.Config.showPanCakeMenu && !Hafas.Config.showPageHeader && Hafas.Config.Switches.useTabNavigation) {
    modelPage.navigation.tabs = Hafas.Config.tabNavigation;
  }

  var me = this;
  // Aufl�sung der Sprach-Keys aus der Config-Datei
  if (modelPage.navigation.hasOwnProperty('pageNavigation')) {
    modelPage.navigation.pageNavigation.forEach(function (item, idx) {
      item.applicationName = Hafas.Modules.i18n.get(item.applicationName);
    });
  }

  // Aufl�sung der Sprach-Keys aus der Config-Datei
  if (modelPage.navigation.hasOwnProperty('headerNavigation')) {
    modelPage.navigation.headerNavigation.forEach(function (item, idx) {
      item.applicationName = Hafas.Modules.i18n.get(item.applicationName);
    });
  }

  if (Hafas.Config.showPageHeader) {
    /* Render PageHeader navigation */
    // Hafas.Modules.Render.render({
    //   file: 'common.page_header.html',
    //   target: 'HFS_PageHeader',
    //   template: 'Common_AtomTplPageHeader',
    //   model: modelPage.navigation
    // }, Hafas.bind(function (html) {
    // }, this));

    // Neu Strawberry 1.5.0.2
    var topLinks = Hafas.Config.Services.pageHeaderNav.filter(function (element) {
      return element.place === 'top';
    });
    var menuLinks = Hafas.Config.Services.pageHeaderNav.filter(function (element) {
      return element.place === 'menu';
    });
    modelPage.navigation.headerNavigation.topLinks = topLinks;
    modelPage.navigation.headerNavigation.menuLinks = menuLinks;
    modelPage.navigation.currentLandIso = Hafas.Config.currLangObj.iso
    modelPage.navigation.currentLandLabel = Hafas.Config.currLangObj.label
    Hafas("#HFS_PageHeader").innerHTML = Hafas.Modules.Render.renderTemplate("Common_AtomTplPageHeader", modelPage.navigation);
  }



  if (typeof modelPage.navigation.tabs != 'undefined' && modelPage.navigation.tabs.length > 0) {
    /* replace i18n-keys */
    modelPage.navigation.tabs.forEach(function (item, idx) {
      item.applicationName = Hafas.Modules.i18n.get(item.applicationName);
    });
  }

  /* Render page navigation */
  // Hafas.Modules.Render.render({
  //   target: 'HFS_TabNavigation',
  //   file: 'common.page_navigation.html',
  //   template: 'Common_AtomTplPageNavigation',
  //   model: modelPage.navigation
  // }, Hafas.bind(function (html) {
  //   var $navContainer = Hafas('#HFS_TabNavigation', false);
  //   Hafas.Util.gui.setVisibility($navContainer,true);
  //   Hafas.Modules.JumpIn.jumpInStartContext(); // Update Strawberry 1.4.0
  //   // Hafas.ps.sub('/app/contextLoaded/' + this.appContext, function(){
  //     Hafas.ps.pub('/common/subscriptions/done');
  //   });
  // }, this));

  // Auskommentiert, da die Kartenoptionen sonst leer gerendert werden /mroe
  /*    if(Hafas.Config.Switches.useSidedrawer) {
        Hafas.Modules.Render.render({
              file: 'common.sidedrawer.html',
              target: 'HFS_PageSideDrawer',
              template: 'Common_SideDrawer',
              model: {}
            },
            Hafas.bind(function(html) {
              window.setTimeout(function(e) {
                _me.Controller.Map.inpMapLocation = Hafas.Core.newType(
                    'hafasSuggest',
                    {
                      loc: "MapLocation",
                      config: Hafas.Config.Suggest,
                      type: "S"
                    }
                );
              }, 1000);
            }, this));
      }*/


  Hafas.ps.pub('/GUI/pageHeaderRendered');

};
